import TomSelect from 'tom-select';

export function initHubspotCompanySelect() {
  if (!$('#hubspot-company-select').length || $('#hubspot-company-select.tomselected').length > 0) return;

  new TomSelect('#hubspot-company-select', {
    placeholder: 'Search for a HubSpot company',
    allowEmptyOption: true,
    valueField: 'id',
    labelField: 'text',
    searchField: ['text'],
    loadThrottle: 500,
    maxOptions: 1000,
    load: function (query, callback) {
      if (!query.length || query.length < 2) return callback();

      fetch(`/user_companies/search_hubspot_companies?q=${encodeURIComponent(query)}`)
        .then(response => response.json())
        .then(data => {
          const results = data.map((company: { id: string; name: string }) => ({
            id: company.id,
            text: company.name
          }));
          callback(results);
        }).catch(() => {
          callback();
        });
    }
  });
}

export function initApiLogoSelect() {
  if (!$('#hubspot-api-logo-select').length || $('#hubspot-api-logo-select.tomselected').length > 0) return;

  const ts = new TomSelect('#hubspot-api-logo-select', {
    placeholder: 'Search for a logo',
    allowEmptyOption: true,
    valueField: 'id',
    labelField: 'text',
    searchField: ['text'],
    loadThrottle: 1000,
    maxOptions: 10,
    render: {
      item: function (data, escape) {
        return `<div class="flex items-center">
          <img src="${data.logo_url}" width="24" height="24" class="mr-2" />
          <span>${escape(data.text)}</span>
        </div>`;
      },
      option: function (data, escape) {
        return `<div class="flex items-center">
          <img src="${data.logo_url}" width="24" height="24" class="mr-2" />
          <span>${escape(data.text)}</span>
        </div>`;
      }
    },
    load: function (query, callback) {
      if (!query.length || query.length < 2) return callback();

      fetch(`/user_companies/search_api_logo?q=${encodeURIComponent(query)}`)
        .then(response => response.json())
        .then(data => {
          const results = data.map(logo => ({
            id: logo.id,
            text: logo.name,
            logo_url: logo.logo_url
          }));
          callback(results);
        }).catch(() => {
          callback();
        });
    }
  });

  const el = document.getElementById('hubspot-api-logo-select') as HTMLSelectElement | null;
  if (el) {
    const initialId = el.dataset.initialId || '';
    const initialText = el.dataset.initialText || initialId;
    const initialLogoUrl = el.dataset.initialLogoUrl || initialId;
    if (initialId) {
      const idValue = `${initialText},${initialLogoUrl}`;
      ts.addOption({ id: idValue, text: initialText, logo_url: initialLogoUrl } as any);
      ts.setValue(idValue, true);
    }
  }
}

export function initAdminUsersCompanySelect() {
  document.querySelectorAll('.admin-user-company-select:not(.tomselected)').forEach((el) => {
    new TomSelect(el as HTMLSelectElement, {
      placeholder: 'Search company...',
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      loadThrottle: 300,
      maxOptions: 20,
      dropdownParent: 'body',
      load: function (query, callback) {
        if (!query.length || query.length < 2) return callback();

        fetch(`/admin/users/search_companies?q=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(data => callback(data))
          .catch(() => callback());
      }
    });
  });
}

const TABLE_MAX_VISIBLE_ROWS = 14;

export function applyCustomerTableMaxHeight() {
  document.querySelectorAll('.custom-table-container').forEach((container) => {
    const wrappers = container.querySelectorAll('.table-wrapper');
    const targets = wrappers.length ? Array.from(wrappers) : [container];

    targets.forEach((element) => {
      const target = element as HTMLElement;
      const firstRow = target.querySelector('tbody tr') as HTMLElement | null;
      if (!firstRow) return;

      const headerHeight = (target.querySelector('thead') as HTMLElement | null)?.offsetHeight ?? 0;
      target.style.maxHeight = `${headerHeight + firstRow.offsetHeight * TABLE_MAX_VISIBLE_ROWS}px`;
      target.style.overflowY = 'auto';
    });
  });
}

export function initCustomersTable() {
  document.querySelectorAll('.customers-table .company-name').forEach((nameElement) => {
    const expandIcon = nameElement.nextElementSibling as HTMLElement;
    if (!expandIcon) {
      return;
    }

    if (nameElement.scrollWidth > nameElement.clientWidth) {
      expandIcon.style.display = 'inline-block';
    } else {
      expandIcon.style.display = 'none';
    }

    expandIcon.addEventListener('click', (event) => {
      event.stopPropagation();
      const target = event.currentTarget as HTMLElement;
      const content = target.getAttribute('data-content');
      const title = target.getAttribute('data-title');
      const modal = $('#fullContentModal');
      const modalTitle = modal.find('[data-modal-target="title"]');
      const modalContent = modal.find('[data-modal-target="content"]');
      modalTitle.text(title);
      modalContent.text(content);
      modal.modal('show');
    });
  });

  $('.customers-table .company-tags').off('click.additional-tags').on('click.additional-tags', '.additional-tags-trigger', function (event) {
    event.stopPropagation();
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    const companyName = target.getAttribute('data-company-name');
    const allTagsJson = target.getAttribute('data-all-tags');

    if (!allTagsJson) return;

    try {
      const allTags = JSON.parse(allTagsJson);
      const modal = $('#all-tags-modal');
      const modalCompanyName = modal.find('#all-tags-modal-label');
      const modalTagsContainer = modal.find('#modal-tags-container');

      modalCompanyName.text(companyName);
      modalTagsContainer.empty();

      allTags.forEach((tag: string) => {
        const tagElement = $(`<span class="score ${getTagColor(tag)} mr-2 mb-2">${tag}</span>`);
        modalTagsContainer.append(tagElement);
      });

      modal.modal('show');
    } catch (e) {
      console.error('Error parsing tags JSON:', e);
    }
  });

  const $customerSuccess = $('.customer-success');
  $customerSuccess.off('click.csClearSearch', '#clear-search');
  $customerSuccess.on('click.csClearSearch', '#clear-search', function (e) {
    e.preventDefault();
    const $form = $('#customer-search-form');
    if ($form.length) {
      $form.find('input[type="text"], input[type="search"], select').each(function () {
        const $input = $(this);
        if ($input.is('input')) {
          if ($input.attr('type') !== 'hidden') {
            $input.val('');
          }
        } else if ($input.is('select')) {
          $input.prop('selectedIndex', 0);
        }
      });
      const formElement = $form[0] as HTMLFormElement;
      formElement.requestSubmit();
    }
  });

  const $form = $('#customer-search-form');
  const $results = $('#customer-content');

  if ($form.length && $results.length) {
    $form.off('ajax:beforeSend.csSearch ajax:complete.csSearch');

    $form.on('ajax:beforeSend.csSearch', () => {
      $('#customer-content .spinner-border').removeClass('d-none');
      $results.css({ opacity: '0.5', 'pointer-events': 'none' });

      $('#clear-search, #full-screen-toggle, #cs-view-dropdown').prop('disabled', true);
      $form.find('.search-field, input[type="submit"]').prop('disabled', true);
    });

    $form.on('ajax:complete.csSearch', () => {
      $('#customer-content .spinner-border').addClass('d-none');
      $results.css({ opacity: '1', 'pointer-events': 'auto' });

      $('#clear-search, #full-screen-toggle, #cs-view-dropdown').prop('disabled', false);
      $form.find('.search-field, input[type="submit"]').prop('disabled', false);
    });
  }

  applyCustomerTableMaxHeight();
}

export function getTagColor(tag: string): string {
  switch (tag) {
    case 'Churn risk':
      return 'no';
    case 'Opt in pending':
      return 'fair';
    case 'Opt in accepted':
      return 'good';
    case 'Opt in declined':
      return 'not-available';
    case 'Focus case':
      return 'focus-case';
    default:
      return 'secondary';
  }
}